import { CompanySecurity } from "../models/company.security";
import BaseService from "./_base.service";

const endpoint = "security/company";

const CompanySecurityService = {
  ...BaseService<CompanySecurity>({ endpoint })
};

export default CompanySecurityService;
